uniform vec3 uColorA;
uniform vec3 uColorB;

varying float vWobble;

void main()
{
    float bulge = max(vWobble, 0.0);

    float mask = smoothstep(0.10, 0.55, bulge);

    vec3 picked = mix(uColorA, uColorB, mask);

    csm_DiffuseColor.rgb = picked;
}
